var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require('@/resources/images/loading.png'),"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }